<ng-container *ngIf="vista === 'tabla'">
  <div class="ds-card">
    <div class="ds-card__cabecera">
      <span class="ds-card__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTRATOS' | translate }}</span>
      <div class="col-10 ds-buscador">
        <span class="p-input-icon-left">
          <img src="assets/icons/ico-buscar-lupa.svg" alt="">
          <input type="text" pInputText placeholder="{{ 'LBL_BUSCAR' | translate }}" [(ngModel)]="filtroContratos">
        </span>
      </div>
    </div>
    <p-table [value]="contratosFiltrados" [loading]="cargandoContratos" [paginator]="true" [rows]="10"
             [alwaysShowPaginator]="true" styleClass="ds-tabla">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTRATO' | translate }}</th>
          <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_FECHAFIRMA' | translate }}</th>
          <th class="text-center">{{ 'LBL_ACCIONES' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-c>
        <tr>
          <td>{{ c.nombrePlantilla || '--' }}</td>
          <td>{{ c.fechaFirma ? (c.fechaFirma | date:'yyyy-MM-dd') : '--' }}</td>
          <td class="text-center">
            <button type="button" pButton class="btn-action-premium" icon="fa fa-eye"
                    title="{{ 'BTN_VISUALIZAR' | translate }}" (click)="previsualizarContrato(c)">
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center">{{ 'MSG_NOHAYREGISTROS' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog [(visible)]="mostrarModalContrato" [modal]="true" [closable]="true" [draggable]="false"
            [style]="{width: '600px'}" styleClass="ds-dialog" class="footer-center"
            header="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTRATO' | translate | uppercase }}">
    <div class="admsb-contrato-preview" [innerHTML]="contenidoContrato"></div>
    <ng-template pTemplate="footer">
      <button type="button" pButton class="btn-primary-full" icon="fa fa-close"
              label="{{ 'BTN_CERRAR' | translate }}" (click)="cerrarModalContrato()"></button>
    </ng-template>
  </p-dialog>
</ng-container>

<ng-container *ngIf="vista === 'matrix'">
  <div class="matrix-contratos-wrapper">
    <!-- Buscador en tiempo real -->
    <div class="matrix-contratos-buscador">
      <span class="p-input-icon-left w-100">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          [placeholder]="'MATRIX.PH_BUSCAR' | translate"
          [(ngModel)]="filtroContratos"
          class="w-100 buscador-input"
        />
      </span>
    </div>

    <!-- Listado de contratos -->
    <div class="matrix-contratos-lista" *ngIf="contratosFiltrados.length > 0">
      <div class="matrix-contrato-card" *ngFor="let c of contratosFiltrados">
        <div class="matrix-contrato-info">
          <span class="contrato-tipo-tag">{{ 'MATRIX.LBL_TIPO_CONTRATO' | translate }}</span>
          <span class="contrato-nombre">{{ c.nombreContratosServicios || c.nombrePlantilla || c.descripcion }}</span>
        </div>
        <div class="matrix-contrato-acciones">
          <div class="contrato-estado-columna">
            <span class="badge-estado" [ngClass]="c.fechaFirma ? 'badge-firmado' : 'badge-pendiente'">
              {{ (c.fechaFirma ? 'MATRIX.LBL_ESTADO_FIRMADO' : 'MATRIX.LBL_ESTADO_PENDIENTE') | translate }}
            </span>
            <span class="contrato-fecha-firma">
              {{ c.fechaFirma ? (c.fechaFirma | date:'dd/MM/yyyy HH:mm:ss') : '--/--/--' }}
            </span>
          </div>
          <button
            type="button"
            class="btn-ojo-visualizar"
            (click)="previsualizarContrato(c)"
            [title]="'MATRIX.LBL_VISUALIZAR' | translate"
          >
            <i class="pi pi-eye"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Estado vacío -->
    <div class="matrix-contratos-vacio" *ngIf="contratosFiltrados.length === 0">
      <i class="pi pi-inbox"></i>
      <p>{{ 'MATRIX.MSG_SIN_CONTRATOS' | translate }}</p>
    </div>
  </div>
</ng-container>
